import { ConfigService } from '@axo/config/ConfigService';
import { Consent } from '@axo/form/feature/axo-form-v2/lib/components';
import { useTranslation } from '@axo/shared/i18n';
import { ButtonSet } from '@axo/ui-core/components/Button';
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Form } from '../../../../../components/Form';
import { Navigation } from '../../../../../components/Navigation';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import useInitiatedTracking from '../../../../../hooks/tracking/useInitiatedTracking';
import { useBroker } from '../../../../../hooks/useBroker';
import { Step6Data } from '../../../FormData.fi.types';
import { CoApplicant } from './CoApplicant';
import { creditStatusConsentFieldOption } from './config';

export const Step6 = () => {
  const { t } = useTranslation();

  const broker = useBroker();
  const { hasCoApplicantForm } = ConfigService.get('product-unsecured-loan')
    .fields[broker];

  const { onChange, onPrevStep, onSubmit, axoFormData } =
    useAxoFormContext<Step6Data>();

  const form = useForm({
    defaultValues: {
      'LoanApplication/PoliticallyInfluential': 'No',
      'Frontend/AddCoApplicant': null,
      'LoanApplication/CreditStatusConsent': false,
    },
    shouldUnregister: true,
    mode: 'onBlur',
  });

  const {
    formState: { isSubmitting, touchedFields },
  } = form;

  useInitiatedTracking({
    shouldTriggerOnInitiated: Object.keys(touchedFields).length > 0,
  });

  const touchedFieldsOverride = useMemo(
    () =>
      Object.keys(axoFormData).filter((key) =>
        key.match(/CoApp|CoPerson|CoCustomer/)
      ),
    [axoFormData]
  );

  return (
    <FormProvider {...form}>
      <Form
        onSubmit={onSubmit}
        onChange={onChange}
        touchedFieldsOverride={touchedFieldsOverride}
      >
        {hasCoApplicantForm && <CoApplicant />}

        <Consent>
          <Consent.Credit options={creditStatusConsentFieldOption} />
        </Consent>

        <ButtonSet justify={'space-between'} responsive>
          <Navigation.Back onClick={onPrevStep}>{t('back')}</Navigation.Back>
          <Navigation.Continue loading={isSubmitting}>
            {t('submit')}
          </Navigation.Continue>
        </ButtonSet>
      </Form>
    </FormProvider>
  );
};
